// @ts-nocheck
import { produce, castDraft, type Draft } from "immer";
import { type GetCachedLensSourceListQuery, type GetLensSourceListQuery } from "../queries";

export const LensSourcesCacheOperations = {
    concat(prevLenses: GetCachedLensSourceListQuery, nextLenses: GetLensSourceListQuery) {
        if (!nextLenses) {
            return prevLenses;
        }

        return produce(prevLenses, (draft: Draft<GetCachedLensSourceListQuery>) => {
            draft.getLensSourceList.cursor = nextLenses.getLensSourceList.cursor;
            draft.getLensSourceList.lensSourceList.push(...castDraft(nextLenses.getLensSourceList.lensSourceList));
        });
    },
};
